export function selectRandomTree(recommendationTrees: CmsData[] = []) {
  if (recommendationTrees.length === 0) {
    return {
      tree: null,
      treeIndex: -1,
    }
  }

  const treeIndex = Math.floor(Math.random() * recommendationTrees.length)
  const tree = recommendationTrees[treeIndex]
  return { tree, treeIndex }
}

// Recursive, so the return type has to be spelled out; TypeScript cannot infer it from itself.
export function reformatTree(tree?: CmsData | null): CmsData | null | undefined {
  if (!tree?.answer_tags) {
    return tree
  }

  const reformattedTree = Object.entries(tree.answer_tags).reduce((acc: CmsData, [key, value]) => {
    acc[key] = reformatTree(value as CmsData)
    return acc
  }, {})

  return { [tree.question_tag]: reformattedTree }
}

export function getRecommendationTree(recommendationTrees: CmsData[] = []) {
  const { tree, treeIndex } = selectRandomTree(recommendationTrees)

  // Reformat tree to a more simplified structure to make it usable with lodash get
  const reformattedTree = reformatTree(tree)

  return {
    tree: reformattedTree,
    treeIndex,
  }
}
